// Animated cards are used by production TermsGrid; static cards remain for Storybook
// and routes that need non-animated markup.
export { AnimatedEquityCard } from "./animated-equity-card";
export { AnimatedGuaranteesCard } from "./animated-guarantees-card";
export {
  AnimatedPricingCard,
  odometerDigitTranslatePercent,
  tokenizeOdometerValue,
} from "./animated-pricing-card";
export type {
  AnimatedPricingCardProps,
  OdometerToken,
} from "./animated-pricing-card";
export { CardLede } from "./card-lede";
export {
  EQUITY_BARS,
  EquityBars,
  PersonCelebrate,
  PersonPlay,
  StaticEquityCard,
} from "./equity-card";
export type { EquityBarDefinition } from "./equity-card";
export {
  BLUE_GLOW_END,
  BLUE_GLOW_START,
  CHECK_END,
  CHECK_START,
  GLASS_END,
  GRAY_GLOW_END,
  GRAY_GLOW_START,
  GUARANTEES_DURATION_MS,
  GuaranteesMock,
  StaticGuaranteesCard,
} from "./guarantees-card";
export {
  FINANCING_END,
  FINANCING_START,
  FEE_END,
  FEE_START,
  MOCK_ENTRANCE_END,
  PRICING_DURATION_MS,
  PRICING_EASING,
  pricingPlaybackEase,
  PricingBrowserMock,
  StaticPricingCard,
  TOTAL_END,
  TOTAL_START,
  segmentProgress,
} from "./pricing-card";
export { StaticRepaymentCard } from "./repayment-card";
export { StaticSpendCard } from "./spend-card";
export { StaticTermsGrid } from "./static-terms-grid";
export type { TermsCopy } from "./types";
export type { TermsMotionDebugProps } from "./use-terms-card-motion";

// Backward-compatible aliases for routes that imported from terms-grid.
export { StaticEquityCard as EquityCard } from "./equity-card";
export { StaticGuaranteesCard as GuaranteesCard } from "./guarantees-card";
export { StaticSpendCard as SpendCard } from "./spend-card";
